import { ReactElement, useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { formatTimeWithSeconds } from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import { IColumn, ISample } from "../../../types";
import TableContainer  from "../../../components/tableContainer";

const columns: IColumn[] = [
  {
    id: "sample",
    label: "Sample ID",
    minWidth: 200
  },
  {
    id: "measured",
    label: "Test Time",
    minWidth: 100,
    align: "center",
    format: value => formatTimeWithSeconds(value)
  },
  {
    id: "actualTemp",
    label: "Actual Temp",
    minWidth: 100,
    align: "right"
  },
  {
    id: "lqd",
    label: "LQD",
    minWidth: 100,
    align: "right",
  },
  {
    id: "superHeat",
    label: "Super Heat",
    minWidth: 100,
    align: "right",
  },
  {
    id: "aimDiff",
    label: "Aim Diff",
    minWidth: 100,
    align: "right",
  }
];


interface ITemperature {
  sample: string;
  measured: number | null;
  actualTemp: number | null;
  lqd: number | null;
  superHeat: number | null;
  aimDiff: number | null;
}

interface IProps {
  data: ISample[];
}

const TundishTemperaturePanel = ({ data }: IProps): ReactElement => {
  const [ rows, setRows ] = useState<ITemperature[]>([]);

  useEffect(() => {

    const result: ITemperature[] = [];

    data.forEach(r => {

      const actualTemp = r.items.find(x => x.name === "Actual Temp");
      const lqd = r.items.find(x => x.name === "LQD");
      const superHeat = r.items.find(x => x.name === "Super Heat");


      result.push({
        sample: r.sampleType.code,
        measured: r.sampleDatetime,
        actualTemp: actualTemp ? actualTemp.value : null,
        lqd: lqd ? lqd.value : null,
        superHeat: superHeat ? superHeat.value : null,
        aimDiff: null
      });

    });

    setRows(result);
  }, data);

  // const createSortHandler = (property: keyof IEquipmentLife) => () => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  return (
    <div>
      <TableContainer>
        <Table stickyHeader={true} size={"small"} >
          <TableHead>
            <TableRow>
              {columns.map((column) =>
                <TableCell
                  className="table-header"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, width: column.minWidth }}>
                  {column.label}
                </TableCell>
              )}
              <TableCell className="table-header"/>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              return (
                <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`temp-row-${index}`}>
                  {columns.map((column: IColumn) => {
                    const value = row[column.id as keyof ITemperature];

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number" ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                  <TableCell/>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TundishTemperaturePanel;
